import { render, staticRenderFns } from "./TableRiskAppraisal595.vue?vue&type=template&id=a1e494ce&scoped=true"
import script from "./TableRiskAppraisal595.vue?vue&type=script&lang=js"
export * from "./TableRiskAppraisal595.vue?vue&type=script&lang=js"
import style0 from "./TableRiskAppraisal595.vue?vue&type=style&index=0&id=a1e494ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1e494ce",
  null
  
)

export default component.exports